<form class="mce-form-section">

    <div class="mce-form-section-title">Voltage Drop</div>

    <div class="mce-form-field-group">

        <div>
            <mat-form-field>
                <mat-label>maximum voltage drop</mat-label>
                <input matInput type="number" placeholder="maximum voltage drop"
                       [formField]="form().voltageDrop.maximumVoltageDrop" />
                <span matSuffix>%</span>
                @for (error of form().voltageDrop.maximumVoltageDrop().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>


        <app-calculation-box [status]="viewState().status" [loading]="viewState().isLoading">
            <div>{{ viewState().voltageDrop }}</div>
            <div>{{ viewState().impedance }}</div>
            <div>{{ viewState().powerLoss }}</div>
        </app-calculation-box>

    </div>


</form>
